module.exports = __webpack_public_path__ + "assets/97730e6a84695c35ade27fa77dd3c3ba.png";